import { b as b$1 } from './chunk-26IU2X5T.mjs';
import o, { keyframes } from 'styled-components';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { Root, Header, Item, Trigger, Content } from '@radix-ui/react-accordion';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

var g=`
  --accordion-header-background: var(--color-neutral-50);
  --accordion-header-color: var(--color-neutral-800);
  --accordion-content-background: var(--color-neutral-0);

  [data-theme='dark'] & {
    --accordion-header-background: var(--color-neutral-500);
    --accordion-header-color: var(--color-neutral-50);
    --accordion-content-background: var(--color-neutral-400);
  }
`,h=`
  --accordion-header-color: var(--color-neutral-800);

  [data-theme='dark'] & {
    --accordion-header-color: var(--color-neutral-50);
  }
`,e="cubic-bezier(0.87, 0, 0.13, 1)",m=keyframes`
  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
`,p=keyframes`
  from {
    height: var(--radix-accordion-content-height);
  }
  to {
    height: 0;
  }
`,u=o(Root)`
  ${({$unstyled:r=!1})=>r?h:g}
`,f=o(Header)`
  display: flex;
  background: var(--accordion-header-background);
  color: var(--accordion-header-color);
  font-size: var(--font-size-regular);
  font-weight: var(--font-weight-bold);
  height: 35px;
  margin: 0;
  padding: 0 16px;
`,v=o(Item)`
  overflow: hidden;
`,b=o(b$1).attrs({icon:faChevronDown,size:"small"})`
  transition: transform 200ms ${e};

  [data-state='open'] & {
    transform: rotate(180deg);
  }
`,x=o(Trigger).attrs(({children:r})=>({children:jsxs(Fragment,{children:[r,jsx(b,{})]})}))`
  all: unset;
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  width: 100%;
`,k=o(Content)`
  background: var(--accordion-content-background);

  &[data-state='open'] {
    animation: ${m} 200ms ${e};
  }

  &[data-state='closed'] {
    animation: ${p} 200ms ${e};
  }
`,y={Root:u,Header:f,Item:v,Trigger:x,Content:k};

export { y as a };
